import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesFR: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        success: {
            verificationOnly: "SheerID s'occupe uniquement de la vérification. Maintenant que votre dossier a été approuvé, veuillez adresser toutes vos questions concernant les conditions de la promotion et/ou l’utilisation du code au service clientèle de <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a>.",
        },
        error: {
            redirectButtonText: 'CONTINUER À TIMBERLAND',
        },
    },
};
